module.exports = __webpack_public_path__ + "static/media/pruef02.ab9fc579.jpeg";